export default "__VITE_ASSET__e2j1YXLW__"